import { Mixins, Component, Prop, VModel } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import AttachmentModel from '@/views/Attachment/model/attachment'

@Component({
    inheritAttrs: false,
})
export default class AttachmentDropzone extends Mixins<MixinInterface>() {
    @Prop() requirments!: Record<string, any>
    @Prop({ default: false }) disablePaste!: boolean
    @VModel() loading!: boolean

    fileInput = null

    get generalRequirments() {
        return this.requirments
            ? this.requirments
            : this.$store.getters.attachmentConstraints.maxBytes
            ? this.$store.getters.attachmentConstraints
            : this.getFileRequirements()
    }

    get allowedFileTypes() {
        return this.generalRequirments?.allowedExtensions
            ? `.${this.generalRequirments?.allowedExtensions.join(',.')}`
            : ''
    }

    get maxBytes() {
        return this.generalRequirments.maxBytes
    }

    dragover(event: any) {
        event.preventDefault()
    }

    async drop(event: any) {
        event.preventDefault()
        await this.uploadFile(event.dataTransfer.files)
    }

    async openFilemanager() {
        let input = document.createElement('input')
        input.type = 'file'
        input.multiple = true
        input.accept = this.allowedFileTypes
        input.onchange = async () => {
            if (input.files) {
                await this.uploadFile(input.files)
                input.remove()
            }
        }
        input.click()
    }

    async uploadFile(files: FileList | Array<File>) {
        if (files.length > 0) {
            let attachments: Array<any> = []
            this.loading = true
            this.$emit('loadingAttachment', true)
            await Promise.all(
                Array.from(files).map(async (file) => {
                    let res = await AttachmentModel.postFile(file)
                    attachments.push(res)
                })
            )
            this.$emit('passFiles', attachments)
            this.loading = false
            this.$emit('loadingAttachment', false)
        }
    }

    dragedover = false

    mounted() {
        window.addEventListener('dragenter', (event) => {
            this.dragedover = true
        })
        window.addEventListener('dragleave', (event) => {
            if (!event.clientY && !event.clientX) this.dragedover = false
        })
        window.addEventListener('drop', (event) => {
            this.dragedover = false
        })

        window.addEventListener('paste', (event) => {
            if (!this.disablePaste) {
                AttachmentModel.retrieveImageFromClipboardAsBlob(event, async (imageDataBase64) => {
                    let arr = [imageDataBase64]
                    await this.uploadFile(arr)
                })
            }
        })
    }
}
